export enum PaymentMethod {
    Stripe,
    Paypal,
}
